import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import StudentLogin from './pages/StudentLogin';
import TeacherLogin from './pages/TeacherLogin';
import StudentSignUp from './pages/StudentSignUp';
import Dashboard from './pages/Dashboard';
import TeacherDash from './pages/TeacherDash';
import About from './pages/About';
import Contact from './pages/Contact';
import Four0Four from './pages/404';
import ProtectedRoute from './ProtectedRoute'; // Import ProtectedRoute
import ProtectedTeacherRoute from './ProtectedTeacherRoute'; // Import ProtectedRoute
import ChairmanProfile from './pages/Chairman';

function App() {
    return (
        <div className="App h-full">
            <div className="content">
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/student-login' element={<StudentLogin />} />
                    <Route path='/teacher-login' element={<TeacherLogin />} />
                    <Route path='/open-an-account' element={<StudentSignUp />} />
                    
                    {/* Protected Routes */}
                    <Route path='/dashboard/:userID' element={<ProtectedRoute element={Dashboard} />} />
                    <Route path='/teacher-dashboard/:userID' element={<ProtectedTeacherRoute element={TeacherDash} />} />
                    
                    {/* Public Routes */}
                    <Route path='/about-us' element={<About />} />
                    <Route path='/chairman-profile' element={<ChairmanProfile />} />
                    <Route path='/contact' element={<Contact />} />
                    <Route path='/404' element={<Four0Four />} />

                    {/* Catch-all Route (Optional) */}
                    <Route path="*" element={<Navigate to="/404" />} />
                </Routes>
            </div>
        </div>
    );
}

export default App;
